import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterUser_template} from "./filterUser_template";
import {filterTag_template} from "./filterTag_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";

declare var ko: any;

export class republishOpportunitiesReport_template extends vnTemplate{

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected authorFilter: filterUser_template;
    protected editorFilter: filterUser_template;
    protected intentFilter : multipleSelector_template;
    protected networkCategoryFilter : multipleSelector_template;
    protected contentTypeFilter : multipleSelector_template;
    protected categoryFilter : multipleSelector_template;
    protected tagFilter: filterTag_template;
    protected filterPreset: filterPreset_template;
    protected exportButtonTooltip: infoButton_template;
    protected deferButtonTooltip: infoButton_template;


    protected getTemplateHtml(): string{

        return `
              
            <div id="list-references">
                <div class="sub-header filter-preset w-justify ">
                        ` + this.filterPreset.getHtmlBuild() + `
                </div>
                
                <div class="sub-header w-justify">
                  
                    <div class="w-left"> 
                                        
                        ${ this.categoryFilter.getHtmlBuild() }        
                        ${ this.contentTypeFilter.getHtmlBuild() }                                     
                        ${ this.networkCategoryFilter.getHtmlBuild() }                    
                        ${ this.intentFilter.getHtmlBuild() } 
                        ${ this.authorFilter.getHtmlBuild() }
                        ${ this.editorFilter.getHtmlBuild() }
                        ${ this.tagFilter.getHtmlBuild() }
                        <div class="w-spec-search icon i-calendar" id="age" style="">
                            <label class="form-label form-label-box" for="age">Days Since Last Publish</label>
                            <input id="ageFilter" data-bind="event: { input: onChangeAgeInput }, valueUpdate : 'afterkeydown', textInput: age" type="number" min="0" class="input-text">
                        </div>       
                        <div class="dropdown select-single">
                            <label class="form-label" for="">View Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                            <div class="dropdown-list" style="left: 0;"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: viewModes">
                                        <input type="radio" name="view" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                     
                </div>
             
            </div>
            
            <div class="sub-header w-justify">              
                <div class="w-left" style="align-items: baseline;">
                    <button data-bind="click: onClickAddToQueue, visible: viewModeSelected() == 1, css: { 'is-disable': isNoArticlesSelected() }" class="btn secondary icon i-export rep-exp"  type="button">Send to Republish Queue<br>and Export</button>
                    <div class="w-tooltips-adv pos-top" data-bind="visible: viewModeSelected() == 1">
                       ` + this.exportButtonTooltip.getHtmlBuild() + `
                    </div>
                    <button data-bind="click: onClickAddToDeferral, visible: viewModeSelected() == 1, css: { 'is-disable': isNoArticlesSelected() }" class="btn secondary icon i-export snooze" type="button">Send to Snooze</button>
                    <div class="w-tooltips-adv pos-top" data-bind="visible: viewModeSelected() == 1">
                       ` + this.deferButtonTooltip.getHtmlBuild() + `
                    </div>
                    <button data-bind="click: onClickDeleteFromQueue, visible: viewModeSelected() == 2, css: { 'is-disable': isNoArticlesSelected() }" class="btn secondary icon i-delete" type="button">Remove Selection from Queue</button>
                    <button data-bind="click: onClickDeleteFromDeferral, visible: viewModeSelected() == 3, css: { 'is-disable': isNoArticlesSelected() }" class="btn secondary icon i-delete" type="button">Remove Selection from Snooze</button>
                    <div data-bind="visible: viewModeSelected() == 1, css: { 'is-disable': isNoArticlesSelected() }" class="w-spec-search icon i-calendar days" style="margin-left: 1rem" id="defer">
                        <label class="form-label form-label-box" for="defer">Days to Snooze for</label>
                        <input id="deferFilter" data-bind="event: { input: onChangeDeferralDaysInput }, valueUpdate : 'afterkeydown', textInput: daysToDefer" type="number" min="0" class="input-text">
                    </div>
                </div>      
            </div>  
                  
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-authors"></div>
                   <div id="selected-editors"></div>
                   <div id="selected-templates"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-categories"></div>
                   <div id="selected-tags"></div>
                   <div id="selected-intents"></div>
                </div>
            </div>
            
            <div class="list-header w-justify">
            
               <div class="w-left">
               </div>

               <div class="w-center">
                    ` + this.filter.getHtmlBuild() + `
               </div>

                <div class="w-right">
                
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>
            
            <div class="w-list-results list-article" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th style="padding:0;">
                                <div style="display: flex;justify-content: center;">
                                    <input type="checkbox" id="selectAll" value="checked" data-bind="checked: isAllRowsSelected, click: onClickSelectAll" />
                                    <label style="" for="selectAll" class="form-label icon i-check"></label>
                                </div>
                            </th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Article Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateMostRecentPublishedStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='dateMostRecentPublishedStatus_DESC', 'list-sort-asc': orderByAndDirection()=='dateMostRecentPublishedStatus_ASC' }">Date Last Published</span></th>
                            <th data-bind="visible: viewModeSelected() == 2"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateAddedToQueue') }, css: { 'list-sort-desc': orderByAndDirection()=='dateAddedToQueue_DESC', 'list-sort-asc': orderByAndDirection()=='dateAddedToQueue_ASC' }">Date Added To Queue</span></th>
                            <th data-bind="visible: viewModeSelected() == 3"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateDeferralExpiry') }, css: { 'list-sort-desc': orderByAndDirection()=='dateDeferralExpiry_DESC', 'list-sort-asc': orderByAndDirection()=='dateDeferralExpiry_ASC' }">Date Snoozed</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'age') }, css: { 'list-sort-desc': orderByAndDirection()=='age_DESC', 'list-sort-asc': orderByAndDirection()=='age_ASC' }">Age</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'author') }, css: { 'list-sort-desc': orderByAndDirection()=='author_DESC', 'list-sort-asc': orderByAndDirection()=='author_ASC' }">Author</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': orderByAndDirection()=='contentType_DESC', 'list-sort-asc': orderByAndDirection()=='contentType_ASC' }">Content Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'intent') }, css: { 'list-sort-desc': orderByAndDirection()=='intent_DESC', 'list-sort-asc': orderByAndDirection()=='intent_ASC' }">Intent</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategory_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategory_ASC' }">Network Category</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'primaryTag') }, css: { 'list-sort-desc': orderByAndDirection()=='primaryTag_DESC', 'list-sort-asc': orderByAndDirection()=='primaryTag_ASC' }">Primary Category</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'primaryCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='primaryCategory_DESC', 'list-sort-asc': orderByAndDirection()=='primaryCategory_ASC' }">Primary Tag</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'last30DaySessions') }, css: { 'list-sort-desc': orderByAndDirection()=='last30DaySessions_DESC', 'list-sort-asc': orderByAndDirection()=='last30DaySessions_ASC' }">30 Day Sessions</span></th>
                            <!--<th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sparkline') }, css: { 'list-sort-desc': orderByAndDirection()=='sparkline_DESC', 'list-sort-asc': orderByAndDirection()=='sparkline_ASC' }">Sparkline</span></th>-->
                            </tr>
                    </thead>
                    <tbody data-bind="foreach: articles">
                        <tr class="cursor">
                             <td style="padding: 0;">

                                <div style="display: flex; justify-content: center;">
                                    <input type="checkbox" value="checked" data-bind="checked: $data.isSelected, value: id, attr:{id: 'result_' + id}, click: $parent.onClickSelect"/>
                                    <label data-bind="text: name, attr:{for: 'result_' + id}" class="form-label icon i-check"></label>
                                </div>
                            </td>
                            <td class="flex">
                                <a style="position: relative" target="_blank" data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span class="icon i-lock"></span>                    
                                    <span class="title" data-bind="text: title"></span>
                                </a>
                            </td>
                            <td>
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: dateMostRecentPublishedStatus == null ? '' : dateMostRecentPublishedStatus"></span></a></td>
                            <td data-bind="visible: $parent.viewModeSelected() == 2">
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: dateAddedToQueue == null ? '' : dateAddedToQueue"></span>
                                </a>
                            </td>
                            <td data-bind="visible: $parent.viewModeSelected() == 3">
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: dateDeferralExpiry == null ? '' : dateDeferralExpiry"></span>
                                </a>
                            </td>
                            <td class="no-wrap">
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: age"></span>
                                </a>
                            </td>            
                            <td class="no-wrap">
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: author"></span>
                                </a>
                            </td>
                            <td>
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: contentType"></span>
                                </a>
                            </td>     
                            <td>
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: intent"></span>
                                </a>
                            </td>
                            <td>
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: networkCategory || 'N/A'"></span>
                                </a>
                            </td>
                            <td>
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: primaryCategory"></span>
                                </a>
                            </td>
                            <td>
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: primaryTag"></span>
                                </a>
                            </td>
                            <td>
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span data-bind="text: last30DaySessions ? (parseInt(last30DaySessions)).toLocaleString('en-US') : 0"></span>
                                </a>
                            </td>
                            <!--<td><span data-bind="text: sparkLine"></span></td>-->
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            
            `;
    }

    protected initPartial(): void{

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 250;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.authorFilter = new filterUser_template("authorFilter", this.getTemplateViewModel(), this.caller);
        this.authorFilter.asMultipleSelectionMode();
        this.authorFilter.setTagContainerId('selected-authors');
        this.authorFilter.setTagContainerCaption('Selected authors:');
        this.authorFilter.setPlaceholderText("Author");
        this.authorFilter.setUniqueIdentifier('authorId');
        this.authorFilter.setIsVisible(false);

        this.editorFilter = new filterUser_template("editorFilter", this.getTemplateViewModel(), this.caller);
        this.editorFilter.asMultipleSelectionMode();
        this.editorFilter.setTagContainerId('selected-editors');
        this.editorFilter.setTagContainerCaption('Selected editors:');
        this.editorFilter.setPlaceholderText("Editor");
        this.editorFilter.setUniqueIdentifier("editorId");

        this.networkCategoryFilter = new multipleSelector_template("networkCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoryFilter.setLabel("network category");
        this.networkCategoryFilter.setFilterContainerClass('margin-neg');
        this.networkCategoryFilter.setTagContainerId('selected-network_categories');
        this.networkCategoryFilter.setTagContainerCaption('Selected network categories:');

        this.contentTypeFilter = new multipleSelector_template("contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setLabel("content type");
        this.contentTypeFilter.setFilterContainerClass('margin-neg');
        this.contentTypeFilter.setTagContainerId('selected-content_types');
        this.contentTypeFilter.setTagContainerCaption('Selected content types:');

        this.categoryFilter = new multipleSelector_template("categoryFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel("primary category");
        this.categoryFilter.setFilterContainerClass('margin-neg');
        this.categoryFilter.setTagContainerId('selected-categories');
        this.categoryFilter.setTagContainerCaption('Selected categories:');

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.intentFilter = new multipleSelector_template("intentFilter", this.getTemplateViewModel(), this.caller);
        this.intentFilter.setLabel("Intent");
        this.intentFilter.setFilterContainerClass('margin-neg');
        this.intentFilter.setTagContainerId('selected-intents');
        this.intentFilter.setTagContainerCaption('Selected Intents:');

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('repub-opportunities');

        let exportButtonTooltipContent = `
        <p>This button will send the selected articles into the republish queue and automatically download a csv with the articles and their metadata.</p>
        <p>Articles remain in the republish queue and will not appear in the Republish Opportunities results until they have been republished or 60 days have passed.</p>
        <p>NOTE: If you change your filtering or pages, your current selection will be cleared.</p>`;

        this.exportButtonTooltip = new infoButton_template('exportButtonTooltip', this.getTemplateViewModel(), this.caller)
        this.exportButtonTooltip.setTitle('');
        this.exportButtonTooltip.setContent(exportButtonTooltipContent);

        let deferButtonTooltipContent = `
        <p>This button will prevent the article from appearing in the Republish Opportunities, until the number of days have passed.</p>
        <p>This decision should be taken based on some element of timelines or to set aside an article that is currently "complete" but will likely not remain so forever.</p>
        <p>NOTE: If you change your filtering or pages, your current selection will be cleared.</p>`;

        this.deferButtonTooltip = new infoButton_template('deferButtonTooltip', this.getTemplateViewModel(), this.caller)
        this.deferButtonTooltip.setTitle('');
        this.deferButtonTooltip.setContent(deferButtonTooltipContent);

    }

    protected getTemplateName(): string{
        return "republishOpportunitiesReport-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return{
            orderBy: ko.observable("last30DaySessions"),
            orderByDirection: ko.observable("DESC"),
            brand: ko.observable(""),
            isAllRowsSelected: ko.observable(false),
            articles: ko.observableArray([]),
            viewModes: ko.observableArray([{id:1,name:"Opportunities"},{id:2,name:"Queue"},{id:3,name:"Snooze"}]),
            viewModeSelectedText: ko.observable("Opportunities"),
            viewModeSelected: ko.observable(1),
            age: ko.observable(90),
            daysToDefer: ko.observable(60),
            orderByAndDirection: ko.observable("last30DaySessions_DESC"),
            permissions: ko.observableArray(this.initPermissions(['article_list_self', 'article_list_brand', 'article_edit_publishingControl'])),
            arrayShowColumns: ko.observableArray([]),
            presetHideColumns: ko.observableArray(),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickAddToQueue: (data, event) => {
                self.onClickAddToQueue();
            },
            onClickAddToDeferral: (data, event) => {
                self.onClickAddToDeferral();
            },
            onClickDeleteFromQueue: (data, event) => {
                self.onClickDeleteFromQueue();
            },
            onClickDeleteFromDeferral: (data, event) => {
                self.onClickDeleteFromDeferral();
            },
            onClickShowRepublishQueue: function (data) {
                self.onClickShowRepublishQueue();
                return true;
            },
            onViewModeChange: function (data) {
                self.onViewModeChange(data);
            },
            onClickSelectAll: function (data, event) {
                return self.onClickSelectAll(data);
            },
            onClickSelect: function (data, event) {
                return self.onClickSelect();
            },
            onChangeAgeInput: function (data, event) {
                self.onChangeAgeInput(event);
            },
            onChangeDeferralDaysInput: function (data, event) {
                self.onChangeDeferralDaysInput(event);
            },
            isNoArticlesSelected: function (data, event) {
                return self.isNoArticlesSelected();
            }
        };
    }

    protected isNoArticlesSelected() {
        let articles = this.getTemplateViewModel().articles();

        return articles.filter(a => a.isSelected).length == 0;
    }

    protected onChangeAgeInput(event) {
        //make sure value is refreshed
        let ageInput = <HTMLInputElement>document.getElementById("ageFilter");
        ageInput.value = String(Math.abs(Number(ageInput.value)));
        this.getTemplateViewModel().age(ageInput.value);

        this.caller.filterList();
        //this.onChangeUserDataListUser(event, this.viewModel[this.idElement].idUser);
    }

    protected onChangeDeferralDaysInput(event) {
        //make sure value is refreshed
        let deferInput = <HTMLInputElement>document.getElementById("deferFilter");
        deferInput.value = String(Math.abs(Number(deferInput.value)));
        this.getTemplateViewModel().daysToDefer(deferInput.value);
    }

    public onClickSelectAll(data) {

        let articles = this.getTemplateViewModel().articles();
        let isAllRowsSelected = data.isAllRowsSelected();

        for(let index in articles) {

            articles[index].isSelected = isAllRowsSelected;
        }

        this.getTemplateViewModel().articles([]);
        this.getTemplateViewModel().articles(articles);

        return true;
    }

    public onClickSelect() {

        let articles = this.getTemplateViewModel().articles();
        this.getTemplateViewModel().articles([]);
        this.getTemplateViewModel().articles(articles);
        return true;
    }



    public getViewModelForRequest(){

        return {
            orderBy : this.viewModel.list.orderBy,
            orderByDirection : this.viewModel.list.orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'repub-opportunities',
            filters      : {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                authors: this.authorFilter.getUsersForRequest(),
                editors: this.editorFilter.getUsersForRequest(),
                networkCategory: this.getTemplateViewModel().networkCategoryFilter.selectedItems,
                intent: this.getTemplateViewModel().intentFilter.selectedItems,
                contentType: this.getTemplateViewModel().contentTypeFilter.selectedItems,
                category: this.getTemplateViewModel().categoryFilter.selectedItems,
                tags: this.tagFilter.getTagsForRequest(),
                hideColumns: this.getTemplateViewModel().presetHideColumns(),
                age: this.getTemplateViewModel().age,
                viewMode: this.getTemplateViewModel().viewModeSelected
            },
        }
    }

    public onClickShowRepublishQueue(){

        this.caller.filterList();
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.articlesListReorder();
    }

    public onClickAddToQueue(){

        let articles = this.getTemplateViewModel().articles();

        let selectedArticles = articles.filter(a => a.isSelected == true);

        //check if at least one selected
        if(selectedArticles.length == 0){
            alert('No articles are selected.');
            return false;
        }

        this.caller.addToRepublishQueue(selectedArticles);
    }

    public onClickAddToDeferral(){

        let articles = this.getTemplateViewModel().articles();
        let daysToDefer = this.getTemplateViewModel().daysToDefer();

        let selectedArticles = articles.filter(a => a.isSelected == true);

        //check if at least one selected
        if(selectedArticles.length == 0){
            alert('No articles are selected.');
            return false;
        }

        if(daysToDefer !== "0"){
            this.caller.addToRepublishDeferral(selectedArticles, daysToDefer);
        }else{
            alert('Days to snooze must be at least one day.');
        }
    }

    public onClickDeleteFromDeferral(){

        let articles = this.getTemplateViewModel().articles();

        let selectedArticles = articles.filter(a => a.isSelected == true);

        //check if at least one selected
        if(selectedArticles.length == 0){
            alert('No articles are selected.');
            return false;
        }

        this.caller.deleteFromRepublishDeferral(selectedArticles);
    }

    public onClickDeleteFromQueue(){

        let articles = this.getTemplateViewModel().articles();

        let selectedArticles = articles.filter(a => a.isSelected == true);

        //check if at least one selected
        if(selectedArticles.length == 0){
            alert('No articles are selected.');
            return false;
        }

        this.caller.deleteFromRepublishQueue(selectedArticles);
    }

    public setDefaultStatusFilters(): void {
        let test = 1;
    }

    private setTagPreset(idTag:number, tag: string): void {

        this.tagFilter.getTemplateViewModel().idTag(idTag);
        this.tagFilter.getTemplateViewModel().tag(tag);
        this.tagFilter.toggleCloseButton();
    }

    private setUserPresetFilter(userFilter: filterUser_template, idUser?: number, name?: string): void {

        userFilter.getTemplateViewModel().idUser(idUser);
        userFilter.getTemplateViewModel().user(name);
        userFilter.toggleCloseButton();
    }

    public setArticles(articles: Array<{ title: string, author: string, dateCreated: string, id: string , reference: string}>): void {

        this.getTemplateViewModel().articles(articles);
    }

    public setIsAllRowsSelected(isAllRowsSelected){

        this.getTemplateViewModel().isAllRowsSelected(isAllRowsSelected);
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setIntentFilterItems(items){

        this.intentFilter.setItems(items);
    }

    public setNetworkCategoryFilterItems(items){

        this.networkCategoryFilter.setItems(items);
    }
    public setContentTypeFilterItems(items){

        this.contentTypeFilter.setItems(items);
    }

    public setCategoryFilterItems(items){

        this.categoryFilter.setItems(items);
    }

    public setAuthorFilter(users) {

        this.getTemplateViewModel().authorFilter.users(users);
    }

    public setEditorFilter(users) {

        this.getTemplateViewModel().editorFilter.users(users);
    }

    protected setTagFilter(tags) {

        this.getTemplateViewModel().tagFilter.tags(tags);
    }

    public setPermissions(permissions) {

        this.authorFilter.setIsVisible(permissions.article_list_brand.read);

        this.getTemplateViewModel().permissions(permissions);
    }

    public setBrand(brand) {

        this.getTemplateViewModel().brand(brand);
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // Multi select filters.
            this.setFilterSelectedItems(this.categoryFilter, urlParams.category);
            this.setFilterSelectedItems(this.contentTypeFilter, urlParams.contentType);
            this.setFilterSelectedItems(this.networkCategoryFilter, urlParams.networkCategory);
            this.setFilterSelectedItems(this.intentFilter, urlParams.intent);

            // keyword filter.
            let keywordString = urlParams.keywords
            if(urlParams.keywords){
                keywordString = urlParams.keywords.replaceAll("+", " ");
            }
            this.filter.getTemplateViewModel().filterKeyword(keywordString);

            // tag filter.
            let nameString = "";
            if(urlParams.tags) {
                this.tagFilter.setSelectedTagsFromRequestParams(urlParams.tags);
            } else {
                this.tagFilter.resetTagContainer();
            }

            // user filters.
            if(urlParams.authors) {
                this.authorFilter.setSelectedUsersFromRequestParams(urlParams.authors);
            } else {
                this.authorFilter.resetTagContainer();
            }

            if(urlParams.editors){
                this.editorFilter.setSelectedUsersFromRequestParams(urlParams.editors)
            } else {
                this.editorFilter.resetTagContainer();
            }

            if(urlParams.age){
                this.getTemplateViewModel().age(urlParams.age);
            }

            if(urlParams.viewMode) {
                this.getTemplateViewModel().viewModeSelected(urlParams.viewMode);
            }
        }
    }

    private onViewModeChange(selected) {

        this.getTemplateViewModel().viewModeSelectedText(selected.name);
        this.caller.filterList();
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(Array.isArray(urlParams)){
            urlParams = urlParams.toString();
        }
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {

                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/republishOpportunitiesReport_template.ts